export const AgencyPicPlaceholder = '/icons/remax-balloon.png' 
export const AgentPicPlaceholder = '/icons/remax-balloon.png' 
export const propertyPicPlaceholder = '/icons/remax-balloon.png' 
